import React from 'react';
import {Box, Button, Typography} from '@mui/material';
import {array, func, node, number, oneOfType, string} from 'prop-types';
import {useTranslation} from 'react-i18next';

import EmptyMessage from './EmptyMessage.jsx';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RefreshIcon from '@mui/icons-material/Refresh';

export const ErrorMessage = ({
  children,
  componentName = 'page',
  error,
  message,
  onRetry,
  actions,
  statusCode,
  ...props
}) => {
  const {t} = useTranslation();

  const defaultActions = [
    <Button
      key="supportButton"
      color="primary"
      variant="contained"
      href="https://support.planet.com/hc/en-us/requests/new"
      target="_blank"
      rel="noreferrer noopener"
      endIcon={<OpenInNewIcon fontSize="small" />}
    >
      {t('errorMessage.buttonReport')}
    </Button>,
  ];

  if (onRetry) {
    defaultActions.push(
      <Button
        key="retryButton"
        color="primary"
        variant="outlined"
        onClick={() => onRetry()}
        startIcon={<RefreshIcon />}
      >
        {t('errorMessage.buttonReload')}
      </Button>
    );
  }

  return (
    <EmptyMessage
      icon={<ErrorOutlineOutlinedIcon color="error" />}
      data-testid="error-message"
      title={
        <>
          {t('error.title')}
          {statusCode && (
            <Box component="span" sx={{marginTop: 1}}>
              {statusCode}
            </Box>
          )}
        </>
      }
      description={message}
      actions={actions || defaultActions}
      {...props}
    >
      {onRetry && (
        <Typography gutterBottom>
          {t('errorMessage.promptReload', {
            componentName: componentName,
          })}
        </Typography>
      )}
    </EmptyMessage>
  );
};

ErrorMessage.propTypes = {
  error: string,
  message: string,
  children: node,
  componentName: string,
  onRetry: func,
  actions: array,
  statusCode: oneOfType([string, number]),
};

export default ErrorMessage;
